// Generated from Color's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ColorCollectionFilterGroups
  = | {
    readonly spot: Iri | Iri[]
  }
  | {
    readonly id: Iri
  }

export const colorCollectionFilterMapping: FilterDefinitionMapping<ColorCollectionFilterGroups> = {
  spot: 'spot',
  id: 'id',
}

export type ColorCollectionSort = 'name'
